import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface GeneralState {
  messagesCount: number;
  messagesIdToClose: number;
  notifications: Array<any>;
}
export function createInitialState(): GeneralState {
  return {
    messagesCount: 0,
    messagesIdToClose: -1,
    notifications: new Array<any>(),
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'general', resettable: true })
export class GeneralStore extends Store<GeneralState> {

  constructor() {
    super(createInitialState());
  }

}
